import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, Suspense as _Suspense, withCtx as _withCtx, createVNode as _createVNode } from "vue";
export function render(_ctx, _cache) {
  return _ctx.error ? _renderSlot(_ctx.$slots, "error", {
    key: 0
  }) : _createVNode(_Suspense, {
    key: 1
  }, {
    default: _withCtx(function () {
      return [_renderSlot(_ctx.$slots, "default")];
    }),
    fallback: _withCtx(function () {
      return [_renderSlot(_ctx.$slots, "fallback")];
    }),
    _: 1
  });
}